import './index.scss';

import { FocusStyleManager, SNPKitProvider } from '@snpjs/core';

import App from './App';
import { UnplannedMaintenanceBoundary } from './features/error/UnplannedMaintenanceBoundary';
import React from 'react';
import ReactDOM from 'react-dom/client';

FocusStyleManager.onlyShowFocusOnTabs();

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<SNPKitProvider>
			<UnplannedMaintenanceBoundary>
				<App />
			</UnplannedMaintenanceBoundary>
		</SNPKitProvider>
	</React.StrictMode>
);
